const $c51840d17bac8a0c$var$Router = {
    init: ()=>{
        document.querySelectorAll("a.navlink").forEach((a)=>{
            a.addEventListener("click", (event)=>{
                event.preventDefault();
                const href = event.target.getAttribute("href");
                $c51840d17bac8a0c$var$Router.go(href);
            });
        });
        window.addEventListener('popstate', (event)=>{
            $c51840d17bac8a0c$var$Router.go(event.state.route, false);
        });
        $c51840d17bac8a0c$var$Router.go(location.pathname);
    },
    go: (route, addToHistory = true)=>{
        if (addToHistory) history.pushState({
            route: route
        }, '', route);
        let pageElement = null;
        switch(route){
            case "/":
                pageElement = document.createElement("home-view");
                break;
            case "/projects":
                pageElement = document.createElement("projects-view");
                break;
            case "/about":
                pageElement = document.createElement("about-view");
                break;
            case "/contact":
                pageElement = document.createElement("contact-view");
                break;
        }
        if (pageElement) {
            let currentPage = document.querySelector("main").firstElementChild;
            if (currentPage) {
                let fadeOut = currentPage.animate([
                    {
                        opacity: 1
                    },
                    {
                        opacity: 0
                    }
                ], {
                    duration: 200
                });
                fadeOut.addEventListener("finish", ()=>{
                    currentPage.remove();
                    document.querySelector("main").appendChild(pageElement);
                    let fadeIn = pageElement.animate([
                        {
                            opacity: 0
                        },
                        {
                            opacity: 1
                        }
                    ], {
                        duration: 200
                    });
                });
            } else document.querySelector("main").appendChild(pageElement);
        }
        window.scrollX = 0;
    }
};
var $c51840d17bac8a0c$export$2e2bcd8739ae039 = $c51840d17bac8a0c$var$Router;


const $2dea89c2310cd25f$var$Categories = {
    category: "all"
};
const $2dea89c2310cd25f$var$proxiedCategories = new Proxy($2dea89c2310cd25f$var$Categories, {
    set (target, property, value) {
        target[property] = value;
        if (property == "category") window.dispatchEvent(new Event("categorychange"));
        return true;
    },
    get (target, property) {
        return target[property];
    }
});
var $2dea89c2310cd25f$export$2e2bcd8739ae039 = $2dea89c2310cd25f$var$proxiedCategories;


const $5bd664b2c2097101$export$ebe90cb607ad99e = {
    duration: 0.3,
    delay: 0,
    endDelay: 0,
    repeat: 0,
    easing: "ease"
};

const $5239c8faf3deeab7$export$2c9e8a9632a706b2 = (min, max, progress)=>-progress * min + progress * max + min;


const $8c2dbee053ff7e50$export$8793edee2d425525 = ()=>{};
const $8c2dbee053ff7e50$export$ea6e51872ab1b721 = (v)=>v;



const $df02ab6d5bda398c$export$504d7abb21fa8c9 = (min, max, value)=>max - min === 0 ? 1 : (value - min) / (max - min);


function $76780cc8b70f8057$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $df02ab6d5bda398c$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $5239c8faf3deeab7$export$2c9e8a9632a706b2)(min, 1, offsetProgress));
    }
}
function $76780cc8b70f8057$export$24dbcec0b26e6d9d(length) {
    const offset = [
        0
    ];
    $76780cc8b70f8057$export$dafee61230cf05c6(offset, length - 1);
    return offset;
}



const $ef9ff69de29665e7$export$7e4aa119212bc614 = (value)=>typeof value === "number";


const $febb50227c34a2a5$export$981cc9ef33696dc8 = (easing)=>Array.isArray(easing) && !(0, $ef9ff69de29665e7$export$7e4aa119212bc614)(easing[0]);


const $f8c3cc00133008b9$export$4997ffc0176396a6 = (min, max, v)=>{
    const rangeSize = max - min;
    return ((v - min) % rangeSize + rangeSize) % rangeSize + min;
};


function $cddb4fbf41ced5d1$export$41c5e731255a462(easing, i) {
    return (0, $febb50227c34a2a5$export$981cc9ef33696dc8)(easing) ? easing[(0, $f8c3cc00133008b9$export$4997ffc0176396a6)(0, easing.length, i)] : easing;
}


const $000ffd8ed17bc014$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);


function $487956b5a5e61377$export$89e29e4ab65e70a9(output, input = (0, $76780cc8b70f8057$export$24dbcec0b26e6d9d)(output.length), easing = (0, $8c2dbee053ff7e50$export$ea6e51872ab1b721)) {
    const length = output.length;
    /**
     * If the input length is lower than the output we
     * fill the input to match. This currently assumes the input
     * is an animation progress value so is a good candidate for
     * moving outside the function.
     */ const remainder = length - input.length;
    remainder > 0 && (0, $76780cc8b70f8057$export$dafee61230cf05c6)(input, remainder);
    return (t)=>{
        let i = 0;
        for(; i < length - 2; i++){
            if (t < input[i + 1]) break;
        }
        let progressInRange = (0, $000ffd8ed17bc014$export$7d15b64cf5a3a4c4)(0, 1, (0, $df02ab6d5bda398c$export$504d7abb21fa8c9)(input[i], input[i + 1], t));
        const segmentEasing = (0, $cddb4fbf41ced5d1$export$41c5e731255a462)(easing, i);
        progressInRange = segmentEasing(progressInRange);
        return (0, $5239c8faf3deeab7$export$2c9e8a9632a706b2)(output[i], output[i + 1], progressInRange);
    };
}

const $0e1b5b1c07f8fb28$export$d81a3021299cadf2 = (easing)=>typeof easing === "object" && Boolean(easing.createAnimation);



/*
  Bezier function generator

  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.

  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.

  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $ef2070365d260bba$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $ef2070365d260bba$var$subdivisionPrecision = 0.0000001;
const $ef2070365d260bba$var$subdivisionMaxIterations = 12;
function $ef2070365d260bba$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $ef2070365d260bba$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $ef2070365d260bba$var$subdivisionPrecision && ++i < $ef2070365d260bba$var$subdivisionMaxIterations);
    return currentT;
}
function $ef2070365d260bba$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $8c2dbee053ff7e50$export$ea6e51872ab1b721;
    const getTForX = (aX)=>$ef2070365d260bba$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $ef2070365d260bba$var$calcBezier(getTForX(t), mY1, mY2);
}


const $e6ebd873cf586cf2$export$be3f796aed065412 = (steps, direction = "end")=>(progress)=>{
        progress = direction === "end" ? Math.min(progress, 0.999) : Math.max(progress, 0.001);
        const expanded = progress * steps;
        const rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
        return (0, $000ffd8ed17bc014$export$7d15b64cf5a3a4c4)(0, 1, rounded / steps);
    };



const $b1486eeffa0df25c$export$77290801a62f77a2 = (easing)=>Array.isArray(easing) && (0, $ef9ff69de29665e7$export$7e4aa119212bc614)(easing[0]);

const $cbc813b470d2e71a$export$f6e2535fb5126e54 = (value)=>typeof value === "function";


const $a5838e105309f1af$var$namedEasings = {
    ease: (0, $ef2070365d260bba$export$2c575fa1d20488bd)(0.25, 0.1, 0.25, 1.0),
    "ease-in": (0, $ef2070365d260bba$export$2c575fa1d20488bd)(0.42, 0.0, 1.0, 1.0),
    "ease-in-out": (0, $ef2070365d260bba$export$2c575fa1d20488bd)(0.42, 0.0, 0.58, 1.0),
    "ease-out": (0, $ef2070365d260bba$export$2c575fa1d20488bd)(0.0, 0.0, 0.58, 1.0)
};
const $a5838e105309f1af$var$functionArgsRegex = /\((.*?)\)/;
function $a5838e105309f1af$export$9681b459c1c8f0f4(definition) {
    // If already an easing function, return
    if ((0, $cbc813b470d2e71a$export$f6e2535fb5126e54)(definition)) return definition;
    // If an easing curve definition, return bezier function
    if ((0, $b1486eeffa0df25c$export$77290801a62f77a2)(definition)) return (0, $ef2070365d260bba$export$2c575fa1d20488bd)(...definition);
    // If we have a predefined easing function, return
    if ($a5838e105309f1af$var$namedEasings[definition]) return $a5838e105309f1af$var$namedEasings[definition];
    // If this is a steps function, attempt to create easing curve
    if (definition.startsWith("steps")) {
        const args = $a5838e105309f1af$var$functionArgsRegex.exec(definition);
        if (args) {
            const argsArray = args[1].split(",");
            return (0, $e6ebd873cf586cf2$export$be3f796aed065412)(parseFloat(argsArray[0]), argsArray[1].trim());
        }
    }
    return 0, $8c2dbee053ff7e50$export$ea6e51872ab1b721;
}


class $6833b212a66a13ab$export$c35d437ae5945fcd {
    constructor(output, keyframes = [
        0,
        1
    ], { easing: easing, duration: initialDuration = (0, $5bd664b2c2097101$export$ebe90cb607ad99e).duration, delay: delay = (0, $5bd664b2c2097101$export$ebe90cb607ad99e).delay, endDelay: endDelay = (0, $5bd664b2c2097101$export$ebe90cb607ad99e).endDelay, repeat: repeat = (0, $5bd664b2c2097101$export$ebe90cb607ad99e).repeat, offset: offset, direction: direction = "normal", autoplay: autoplay = true } = {}){
        this.startTime = null;
        this.rate = 1;
        this.t = 0;
        this.cancelTimestamp = null;
        this.easing = (0, $8c2dbee053ff7e50$export$ea6e51872ab1b721);
        this.duration = 0;
        this.totalDuration = 0;
        this.repeat = 0;
        this.playState = "idle";
        this.finished = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
        easing = easing || (0, $5bd664b2c2097101$export$ebe90cb607ad99e).easing;
        if ((0, $0e1b5b1c07f8fb28$export$d81a3021299cadf2)(easing)) {
            const custom = easing.createAnimation(keyframes);
            easing = custom.easing;
            keyframes = custom.keyframes || keyframes;
            initialDuration = custom.duration || initialDuration;
        }
        this.repeat = repeat;
        this.easing = (0, $febb50227c34a2a5$export$981cc9ef33696dc8)(easing) ? (0, $8c2dbee053ff7e50$export$ea6e51872ab1b721) : (0, $a5838e105309f1af$export$9681b459c1c8f0f4)(easing);
        this.updateDuration(initialDuration);
        const interpolate$1 = (0, $487956b5a5e61377$export$89e29e4ab65e70a9)(keyframes, offset, (0, $febb50227c34a2a5$export$981cc9ef33696dc8)(easing) ? easing.map((0, $a5838e105309f1af$export$9681b459c1c8f0f4)) : (0, $8c2dbee053ff7e50$export$ea6e51872ab1b721));
        this.tick = (timestamp)=>{
            var _a;
            // TODO: Temporary fix for OptionsResolver typing
            delay;
            let t = 0;
            if (this.pauseTime !== undefined) t = this.pauseTime;
            else t = (timestamp - this.startTime) * this.rate;
            this.t = t;
            // Convert to seconds
            t /= 1000;
            // Rebase on delay
            t = Math.max(t - delay, 0);
            /**
             * If this animation has finished, set the current time
             * to the total duration.
             */ if (this.playState === "finished" && this.pauseTime === undefined) t = this.totalDuration;
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = t / this.duration;
            // TODO progress += iterationStart
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            if (!iterationProgress && progress >= 1) iterationProgress = 1;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ iterationProgress === 1 && currentIteration--;
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const iterationIsOdd = currentIteration % 2;
            if (direction === "reverse" || direction === "alternate" && iterationIsOdd || direction === "alternate-reverse" && !iterationIsOdd) iterationProgress = 1 - iterationProgress;
            const p = t >= this.totalDuration ? 1 : Math.min(iterationProgress, 1);
            const latest = interpolate$1(this.easing(p));
            output(latest);
            const isAnimationFinished = this.pauseTime === undefined && (this.playState === "finished" || t >= this.totalDuration + endDelay);
            if (isAnimationFinished) {
                this.playState = "finished";
                (_a = this.resolve) === null || _a === void 0 || _a.call(this, latest);
            } else if (this.playState !== "idle") this.frameRequestId = requestAnimationFrame(this.tick);
        };
        if (autoplay) this.play();
    }
    play() {
        const now = performance.now();
        this.playState = "running";
        if (this.pauseTime !== undefined) this.startTime = now - this.pauseTime;
        else if (!this.startTime) this.startTime = now;
        this.cancelTimestamp = this.startTime;
        this.pauseTime = undefined;
        this.frameRequestId = requestAnimationFrame(this.tick);
    }
    pause() {
        this.playState = "paused";
        this.pauseTime = this.t;
    }
    finish() {
        this.playState = "finished";
        this.tick(0);
    }
    stop() {
        var _a;
        this.playState = "idle";
        if (this.frameRequestId !== undefined) cancelAnimationFrame(this.frameRequestId);
        (_a = this.reject) === null || _a === void 0 || _a.call(this, false);
    }
    cancel() {
        this.stop();
        this.tick(this.cancelTimestamp);
    }
    reverse() {
        this.rate *= -1;
    }
    commitStyles() {}
    updateDuration(duration) {
        this.duration = duration;
        this.totalDuration = duration * (this.repeat + 1);
    }
    get currentTime() {
        return this.t;
    }
    set currentTime(t) {
        if (this.pauseTime !== undefined || this.rate === 0) this.pauseTime = t;
        else this.startTime = performance.now() - t / this.rate;
    }
    get playbackRate() {
        return this.rate;
    }
    set playbackRate(rate) {
        this.rate = rate;
    }
}


var $4fd1ae9b00853f6f$export$491112666e282270 = function() {};
var $4fd1ae9b00853f6f$export$f5708dca728d7177 = function() {};


/**
 * The MotionValue tracks the state of a single animatable
 * value. Currently, updatedAt and current are unused. The
 * long term idea is to use this to minimise the number
 * of DOM reads, and to abstract the DOM interactions here.
 */ class $f1fe0ff64005dcb1$export$8cea36d14ee64562 {
    setAnimation(animation) {
        this.animation = animation;
        animation === null || animation === void 0 || animation.finished.then(()=>this.clearAnimation()).catch(()=>{});
    }
    clearAnimation() {
        this.animation = this.generator = undefined;
    }
}


const $311e1e8e1f9e358b$var$data = new WeakMap();
function $311e1e8e1f9e358b$export$213eea93596b44f(element) {
    if (!$311e1e8e1f9e358b$var$data.has(element)) $311e1e8e1f9e358b$var$data.set(element, {
        transforms: [],
        values: new Map()
    });
    return $311e1e8e1f9e358b$var$data.get(element);
}
function $311e1e8e1f9e358b$export$c0999ba824977ca6(motionValues, name) {
    if (!motionValues.has(name)) motionValues.set(name, new (0, $f1fe0ff64005dcb1$export$8cea36d14ee64562)());
    return motionValues.get(name);
}


function $fc2fda2411a55cab$export$20e507e47fae79fd(array, item) {
    array.indexOf(item) === -1 && array.push(item);
}
function $fc2fda2411a55cab$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    index > -1 && arr.splice(index, 1);
}



/**
 * A list of all transformable axes. We'll use this list to generated a version
 * of each axes for each transform.
 */ const $348b94d3fcbeadef$export$a9a762b9618d4a18 = [
    "",
    "X",
    "Y",
    "Z"
];
/**
 * An ordered array of each transformable value. By default, transform values
 * will be sorted to this order.
 */ const $348b94d3fcbeadef$var$order = [
    "translate",
    "scale",
    "rotate",
    "skew"
];
const $348b94d3fcbeadef$export$97b5d3c90609c212 = {
    x: "translateX",
    y: "translateY",
    z: "translateZ"
};
const $348b94d3fcbeadef$var$rotation = {
    syntax: "<angle>",
    initialValue: "0deg",
    toDefaultUnit: (v)=>v + "deg"
};
const $348b94d3fcbeadef$var$baseTransformProperties = {
    translate: {
        syntax: "<length-percentage>",
        initialValue: "0px",
        toDefaultUnit: (v)=>v + "px"
    },
    rotate: $348b94d3fcbeadef$var$rotation,
    scale: {
        syntax: "<number>",
        initialValue: 1,
        toDefaultUnit: (0, $8c2dbee053ff7e50$export$ea6e51872ab1b721)
    },
    skew: $348b94d3fcbeadef$var$rotation
};
const $348b94d3fcbeadef$export$a9dad2abc3d443d = new Map();
const $348b94d3fcbeadef$export$7bbd29b1fa8b68d4 = (name)=>`--motion-${name}`;
/**
 * Generate a list of every possible transform key
 */ const $348b94d3fcbeadef$var$transforms = [
    "x",
    "y",
    "z"
];
$348b94d3fcbeadef$var$order.forEach((name)=>{
    $348b94d3fcbeadef$export$a9a762b9618d4a18.forEach((axis)=>{
        $348b94d3fcbeadef$var$transforms.push(name + axis);
        $348b94d3fcbeadef$export$a9dad2abc3d443d.set($348b94d3fcbeadef$export$7bbd29b1fa8b68d4(name + axis), $348b94d3fcbeadef$var$baseTransformProperties[name]);
    });
});
/**
 * A function to use with Array.sort to sort transform keys by their default order.
 */ const $348b94d3fcbeadef$export$11410fe03e8c4042 = (a, b)=>$348b94d3fcbeadef$var$transforms.indexOf(a) - $348b94d3fcbeadef$var$transforms.indexOf(b);
/**
 * Provide a quick way to check if a string is the name of a transform
 */ const $348b94d3fcbeadef$var$transformLookup = new Set($348b94d3fcbeadef$var$transforms);
const $348b94d3fcbeadef$export$8a546e9da811625d = (name)=>$348b94d3fcbeadef$var$transformLookup.has(name);
const $348b94d3fcbeadef$export$40eba1f1af915c93 = (element, name)=>{
    // Map x to translateX etc
    if ($348b94d3fcbeadef$export$97b5d3c90609c212[name]) name = $348b94d3fcbeadef$export$97b5d3c90609c212[name];
    const { transforms: transforms } = (0, $311e1e8e1f9e358b$export$213eea93596b44f)(element);
    (0, $fc2fda2411a55cab$export$20e507e47fae79fd)(transforms, name);
    /**
     * TODO: An optimisation here could be to cache the transform in element data
     * and only update if this has changed.
     */ element.style.transform = $348b94d3fcbeadef$export$785216816cb6f870(transforms);
};
const $348b94d3fcbeadef$export$785216816cb6f870 = (transforms)=>transforms.sort($348b94d3fcbeadef$export$11410fe03e8c4042).reduce($348b94d3fcbeadef$var$transformListToString, "").trim();
const $348b94d3fcbeadef$var$transformListToString = (template, name)=>`${template} ${name}(var(${$348b94d3fcbeadef$export$7bbd29b1fa8b68d4(name)}))`;


const $97eae2e568a82834$export$30a9abfd5fb9f5f6 = (name)=>name.startsWith("--");
const $97eae2e568a82834$export$7a740cb9e3dd106d = new Set();
function $97eae2e568a82834$export$9fdd8c2f6f59adb0(name) {
    if ($97eae2e568a82834$export$7a740cb9e3dd106d.has(name)) return;
    $97eae2e568a82834$export$7a740cb9e3dd106d.add(name);
    try {
        const { syntax: syntax, initialValue: initialValue } = (0, $348b94d3fcbeadef$export$a9dad2abc3d443d).has(name) ? (0, $348b94d3fcbeadef$export$a9dad2abc3d443d).get(name) : {};
        CSS.registerProperty({
            name: name,
            inherits: false,
            syntax: syntax,
            initialValue: initialValue
        });
    } catch (e) {}
}


const $4b4a0c48a96411e5$export$2da9be4cfdb689b1 = {
    ms: (seconds)=>seconds * 1000,
    s: (milliseconds)=>milliseconds / 1000
};




const $1d8d0809bbc8866f$var$testAnimation = (keyframes, options)=>document.createElement("div").animate(keyframes, options);
const $1d8d0809bbc8866f$var$featureTests = {
    cssRegisterProperty: ()=>typeof CSS !== "undefined" && Object.hasOwnProperty.call(CSS, "registerProperty"),
    waapi: ()=>Object.hasOwnProperty.call(Element.prototype, "animate"),
    partialKeyframes: ()=>{
        try {
            $1d8d0809bbc8866f$var$testAnimation({
                opacity: [
                    1
                ]
            });
        } catch (e) {
            return false;
        }
        return true;
    },
    finished: ()=>Boolean($1d8d0809bbc8866f$var$testAnimation({
            opacity: [
                0,
                1
            ]
        }, {
            duration: 0.001
        }).finished),
    linearEasing: ()=>{
        try {
            $1d8d0809bbc8866f$var$testAnimation({
                opacity: 0
            }, {
                easing: "linear(0, 1)"
            });
        } catch (e) {
            return false;
        }
        return true;
    }
};
const $1d8d0809bbc8866f$var$results = {};
const $1d8d0809bbc8866f$export$cde6a56f9669daf6 = {};
for(const key in $1d8d0809bbc8866f$var$featureTests)$1d8d0809bbc8866f$export$cde6a56f9669daf6[key] = ()=>{
    if ($1d8d0809bbc8866f$var$results[key] === undefined) $1d8d0809bbc8866f$var$results[key] = $1d8d0809bbc8866f$var$featureTests[key]();
    return $1d8d0809bbc8866f$var$results[key];
};


// Create a linear easing point for every x second
const $faeb0e3815256700$var$resolution = 0.015;
const $faeb0e3815256700$export$a74bbb7e96c8ced4 = (easing, duration)=>{
    let points = "";
    const numPoints = Math.round(duration / $faeb0e3815256700$var$resolution);
    for(let i = 0; i < numPoints; i++)points += easing((0, $df02ab6d5bda398c$export$504d7abb21fa8c9)(0, numPoints - 1, i)) + ", ";
    return points.substring(0, points.length - 2);
};
const $faeb0e3815256700$export$284d1118c33f9836 = (easing, duration)=>{
    if ((0, $cbc813b470d2e71a$export$f6e2535fb5126e54)(easing)) return (0, $1d8d0809bbc8866f$export$cde6a56f9669daf6).linearEasing() ? `linear(${$faeb0e3815256700$export$a74bbb7e96c8ced4(easing, duration)})` : (0, $5bd664b2c2097101$export$ebe90cb607ad99e).easing;
    else return (0, $b1486eeffa0df25c$export$77290801a62f77a2)(easing) ? $faeb0e3815256700$export$2523b8f0bd8f44cb(easing) : easing;
};
const $faeb0e3815256700$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;



function $ce61df036a16535b$export$3d2f5b3e7004e0cf(keyframes, readInitialValue) {
    for(let i = 0; i < keyframes.length; i++)if (keyframes[i] === null) keyframes[i] = i ? keyframes[i - 1] : readInitialValue();
    return keyframes;
}
const $ce61df036a16535b$export$388e66a97327a012 = (keyframes)=>Array.isArray(keyframes) ? keyframes : [
        keyframes
    ];




function $c198c52b86dad803$export$b6557f397a74f857(key) {
    if ((0, $348b94d3fcbeadef$export$97b5d3c90609c212)[key]) key = (0, $348b94d3fcbeadef$export$97b5d3c90609c212)[key];
    return (0, $348b94d3fcbeadef$export$8a546e9da811625d)(key) ? (0, $348b94d3fcbeadef$export$7bbd29b1fa8b68d4)(key) : key;
}



const $fd426721c0ea44ce$export$1d567c320f4763bc = {
    get: (element, name)=>{
        name = (0, $c198c52b86dad803$export$b6557f397a74f857)(name);
        let value = (0, $97eae2e568a82834$export$30a9abfd5fb9f5f6)(name) ? element.style.getPropertyValue(name) : getComputedStyle(element)[name];
        if (!value && value !== 0) {
            const definition = (0, $348b94d3fcbeadef$export$a9dad2abc3d443d).get(name);
            if (definition) value = definition.initialValue;
        }
        return value;
    },
    set: (element, name, value)=>{
        name = (0, $c198c52b86dad803$export$b6557f397a74f857)(name);
        if ((0, $97eae2e568a82834$export$30a9abfd5fb9f5f6)(name)) element.style.setProperty(name, value);
        else element.style[name] = value;
    }
};



function $d02340a0b8eda13b$export$3cc6f911ef1fd837(animation, needsCommit = true) {
    if (!animation || animation.playState === "finished") return;
    // Suppress error thrown by WAAPI
    try {
        if (animation.stop) animation.stop();
        else {
            needsCommit && animation.commitStyles();
            animation.cancel();
        }
    } catch (e) {}
}


const $2a81f6ce54bbc186$export$844ec244b1367d54 = (value)=>typeof value === "string";


function $ad3259e3871471aa$export$4bcf070800a2fd35(keyframes, definition) {
    var _a;
    let toUnit = (definition === null || definition === void 0 ? void 0 : definition.toDefaultUnit) || (0, $8c2dbee053ff7e50$export$ea6e51872ab1b721);
    const finalKeyframe = keyframes[keyframes.length - 1];
    if ((0, $2a81f6ce54bbc186$export$844ec244b1367d54)(finalKeyframe)) {
        const unit = ((_a = finalKeyframe.match(/(-?[\d.]+)([a-z%]*)/)) === null || _a === void 0 ? void 0 : _a[2]) || "";
        if (unit) toUnit = (value)=>value + unit;
    }
    return toUnit;
}


function $a3dd283a70afc00d$var$getDevToolsRecord() {
    return window.__MOTION_DEV_TOOLS_RECORD;
}
function $a3dd283a70afc00d$export$c76cd972d26986f9(element, key, keyframesDefinition, options = {}, AnimationPolyfill) {
    const record = $a3dd283a70afc00d$var$getDevToolsRecord();
    const isRecording = options.record !== false && record;
    let animation;
    let { duration: duration = (0, $5bd664b2c2097101$export$ebe90cb607ad99e).duration, delay: delay = (0, $5bd664b2c2097101$export$ebe90cb607ad99e).delay, endDelay: endDelay = (0, $5bd664b2c2097101$export$ebe90cb607ad99e).endDelay, repeat: repeat = (0, $5bd664b2c2097101$export$ebe90cb607ad99e).repeat, easing: easing = (0, $5bd664b2c2097101$export$ebe90cb607ad99e).easing, persist: persist = false, direction: direction, offset: offset, allowWebkitAcceleration: allowWebkitAcceleration = false, autoplay: autoplay = true } = options;
    const data = (0, $311e1e8e1f9e358b$export$213eea93596b44f)(element);
    const valueIsTransform = (0, $348b94d3fcbeadef$export$8a546e9da811625d)(key);
    let canAnimateNatively = (0, $1d8d0809bbc8866f$export$cde6a56f9669daf6).waapi();
    /**
     * If this is an individual transform, we need to map its
     * key to a CSS variable and update the element's transform style
     */ valueIsTransform && (0, $348b94d3fcbeadef$export$40eba1f1af915c93)(element, key);
    const name = (0, $c198c52b86dad803$export$b6557f397a74f857)(key);
    const motionValue = (0, $311e1e8e1f9e358b$export$c0999ba824977ca6)(data.values, name);
    /**
     * Get definition of value, this will be used to convert numerical
     * keyframes into the default value type.
     */ const definition = (0, $348b94d3fcbeadef$export$a9dad2abc3d443d).get(name);
    /**
     * Stop the current animation, if any. Because this will trigger
     * commitStyles (DOM writes) and we might later trigger DOM reads,
     * this is fired now and we return a factory function to create
     * the actual animation that can get called in batch,
     */ (0, $d02340a0b8eda13b$export$3cc6f911ef1fd837)(motionValue.animation, !((0, $0e1b5b1c07f8fb28$export$d81a3021299cadf2)(easing) && motionValue.generator) && options.record !== false);
    /**
     * Batchable factory function containing all DOM reads.
     */ return ()=>{
        const readInitialValue = ()=>{
            var _a, _b;
            return (_b = (_a = (0, $fd426721c0ea44ce$export$1d567c320f4763bc).get(element, name)) !== null && _a !== void 0 ? _a : definition === null || definition === void 0 ? void 0 : definition.initialValue) !== null && _b !== void 0 ? _b : 0;
        };
        /**
         * Replace null values with the previous keyframe value, or read
         * it from the DOM if it's the first keyframe.
         */ let keyframes = (0, $ce61df036a16535b$export$3d2f5b3e7004e0cf)((0, $ce61df036a16535b$export$388e66a97327a012)(keyframesDefinition), readInitialValue);
        /**
         * Detect unit type of keyframes.
         */ const toUnit = (0, $ad3259e3871471aa$export$4bcf070800a2fd35)(keyframes, definition);
        if ((0, $0e1b5b1c07f8fb28$export$d81a3021299cadf2)(easing)) {
            const custom = easing.createAnimation(keyframes, key !== "opacity", readInitialValue, name, motionValue);
            easing = custom.easing;
            keyframes = custom.keyframes || keyframes;
            duration = custom.duration || duration;
        }
        /**
         * If this is a CSS variable we need to register it with the browser
         * before it can be animated natively. We also set it with setProperty
         * rather than directly onto the element.style object.
         */ if ((0, $97eae2e568a82834$export$30a9abfd5fb9f5f6)(name)) {
            if ((0, $1d8d0809bbc8866f$export$cde6a56f9669daf6).cssRegisterProperty()) (0, $97eae2e568a82834$export$9fdd8c2f6f59adb0)(name);
            else canAnimateNatively = false;
        }
        /**
         * If we've been passed a custom easing function, and this browser
         * does **not** support linear() easing, and the value is a transform
         * (and thus a pure number) we can still support the custom easing
         * by falling back to the animation polyfill.
         */ if (valueIsTransform && !(0, $1d8d0809bbc8866f$export$cde6a56f9669daf6).linearEasing() && ((0, $cbc813b470d2e71a$export$f6e2535fb5126e54)(easing) || (0, $febb50227c34a2a5$export$981cc9ef33696dc8)(easing) && easing.some((0, $cbc813b470d2e71a$export$f6e2535fb5126e54)))) canAnimateNatively = false;
        /**
         * If we can animate this value with WAAPI, do so.
         */ if (canAnimateNatively) {
            /**
             * Convert numbers to default value types. Currently this only supports
             * transforms but it could also support other value types.
             */ if (definition) keyframes = keyframes.map((value)=>(0, $ef9ff69de29665e7$export$7e4aa119212bc614)(value) ? definition.toDefaultUnit(value) : value);
            /**
             * If this browser doesn't support partial/implicit keyframes we need to
             * explicitly provide one.
             */ if (keyframes.length === 1 && (!(0, $1d8d0809bbc8866f$export$cde6a56f9669daf6).partialKeyframes() || isRecording)) keyframes.unshift(readInitialValue());
            const animationOptions = {
                delay: (0, $4b4a0c48a96411e5$export$2da9be4cfdb689b1).ms(delay),
                duration: (0, $4b4a0c48a96411e5$export$2da9be4cfdb689b1).ms(duration),
                endDelay: (0, $4b4a0c48a96411e5$export$2da9be4cfdb689b1).ms(endDelay),
                easing: !(0, $febb50227c34a2a5$export$981cc9ef33696dc8)(easing) ? (0, $faeb0e3815256700$export$284d1118c33f9836)(easing, duration) : undefined,
                direction: direction,
                iterations: repeat + 1,
                fill: "both"
            };
            animation = element.animate({
                [name]: keyframes,
                offset: offset,
                easing: (0, $febb50227c34a2a5$export$981cc9ef33696dc8)(easing) ? easing.map((thisEasing)=>(0, $faeb0e3815256700$export$284d1118c33f9836)(thisEasing, duration)) : undefined
            }, animationOptions);
            /**
             * Polyfill finished Promise in browsers that don't support it
             */ if (!animation.finished) animation.finished = new Promise((resolve, reject)=>{
                animation.onfinish = resolve;
                animation.oncancel = reject;
            });
            const target = keyframes[keyframes.length - 1];
            animation.finished.then(()=>{
                if (persist) return;
                // Apply styles to target
                (0, $fd426721c0ea44ce$export$1d567c320f4763bc).set(element, name, target);
                // Ensure fill modes don't persist
                animation.cancel();
            }).catch((0, $8c2dbee053ff7e50$export$8793edee2d425525));
            /**
             * This forces Webkit to run animations on the main thread by exploiting
             * this condition:
             * https://trac.webkit.org/browser/webkit/trunk/Source/WebCore/platform/graphics/ca/GraphicsLayerCA.cpp?rev=281238#L1099
             *
             * This fixes Webkit's timing bugs, like accelerated animations falling
             * out of sync with main thread animations and massive delays in starting
             * accelerated animations in WKWebView.
             */ if (!allowWebkitAcceleration) animation.playbackRate = 1.000001;
        /**
             * If we can't animate the value natively then we can fallback to the numbers-only
             * polyfill for transforms.
             */ } else if (AnimationPolyfill && valueIsTransform) {
            /**
             * If any keyframe is a string (because we measured it from the DOM), we need to convert
             * it into a number before passing to the Animation polyfill.
             */ keyframes = keyframes.map((value)=>typeof value === "string" ? parseFloat(value) : value);
            /**
             * If we only have a single keyframe, we need to create an initial keyframe by reading
             * the current value from the DOM.
             */ if (keyframes.length === 1) keyframes.unshift(parseFloat(readInitialValue()));
            animation = new AnimationPolyfill((latest)=>{
                (0, $fd426721c0ea44ce$export$1d567c320f4763bc).set(element, name, toUnit ? toUnit(latest) : latest);
            }, keyframes, Object.assign(Object.assign({}, options), {
                duration: duration,
                easing: easing
            }));
        } else {
            const target = keyframes[keyframes.length - 1];
            (0, $fd426721c0ea44ce$export$1d567c320f4763bc).set(element, name, definition && (0, $ef9ff69de29665e7$export$7e4aa119212bc614)(target) ? definition.toDefaultUnit(target) : target);
        }
        if (isRecording) record(element, key, keyframes, {
            duration: duration,
            delay: delay,
            easing: easing,
            repeat: repeat,
            offset: offset
        }, "motion-one");
        motionValue.setAnimation(animation);
        if (animation && !autoplay) animation.pause();
        return animation;
    };
}


const $14bcec4e4efa8097$export$d2312e68e1f5ad00 = (options, key)=>/**
 * TODO: Make test for this
 * Always return a new object otherwise delay is overwritten by results of stagger
 * and this results in no stagger
 */ options[key] ? Object.assign(Object.assign({}, options), options[key]) : Object.assign({}, options);


function $f571a32549c818c8$export$90ceba2564a894f8(elements, selectorCache) {
    var _a;
    if (typeof elements === "string") {
        if (selectorCache) {
            (_a = selectorCache[elements]) !== null && _a !== void 0 ? _a : selectorCache[elements] = document.querySelectorAll(elements);
            elements = selectorCache[elements];
        } else elements = document.querySelectorAll(elements);
    } else if (elements instanceof Element) elements = [
        elements
    ];
    /**
     * Return an empty array
     */ return Array.from(elements || []);
}




const $5bb653941caaff3c$var$createAnimation = (factory)=>factory();
const $5bb653941caaff3c$export$c5e4bb50450218c1 = (animationFactory, options, duration = (0, $5bd664b2c2097101$export$ebe90cb607ad99e).duration)=>{
    return new Proxy({
        animations: animationFactory.map($5bb653941caaff3c$var$createAnimation).filter(Boolean),
        duration: duration,
        options: options
    }, $5bb653941caaff3c$export$cc1adf6fb659c762);
};
/**
 * TODO:
 * Currently this returns the first animation, ideally it would return
 * the first active animation.
 */ const $5bb653941caaff3c$var$getActiveAnimation = (state)=>state.animations[0];
const $5bb653941caaff3c$export$cc1adf6fb659c762 = {
    get: (target, key)=>{
        const activeAnimation = $5bb653941caaff3c$var$getActiveAnimation(target);
        switch(key){
            case "duration":
                return target.duration;
            case "currentTime":
                return (0, $4b4a0c48a96411e5$export$2da9be4cfdb689b1).s((activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation[key]) || 0);
            case "playbackRate":
            case "playState":
                return activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation[key];
            case "finished":
                if (!target.finished) target.finished = Promise.all(target.animations.map($5bb653941caaff3c$var$selectFinished)).catch((0, $8c2dbee053ff7e50$export$8793edee2d425525));
                return target.finished;
            case "stop":
                return ()=>{
                    target.animations.forEach((animation)=>(0, $d02340a0b8eda13b$export$3cc6f911ef1fd837)(animation));
                };
            case "forEachNative":
                /**
                 * This is for internal use only, fire a callback for each
                 * underlying animation.
                 */ return (callback)=>{
                    target.animations.forEach((animation)=>callback(animation, target));
                };
            default:
                return typeof (activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation[key]) === "undefined" ? undefined : ()=>target.animations.forEach((animation)=>animation[key]());
        }
    },
    set: (target, key, value)=>{
        switch(key){
            case "currentTime":
                value = (0, $4b4a0c48a96411e5$export$2da9be4cfdb689b1).ms(value);
            // Fall-through
            case "playbackRate":
                for(let i = 0; i < target.animations.length; i++)target.animations[i][key] = value;
                return true;
        }
        return false;
    }
};
const $5bb653941caaff3c$var$selectFinished = (animation)=>animation.finished;




function $9c5540e6e2a50ade$export$ef0b4d89074db4d0(duration = 0.1, { start: start = 0, from: from = 0, easing: easing } = {}) {
    return (i, total)=>{
        const fromIndex = (0, $ef9ff69de29665e7$export$7e4aa119212bc614)(from) ? from : $9c5540e6e2a50ade$export$a7952f4918e96441(from, total);
        const distance = Math.abs(fromIndex - i);
        let delay = duration * distance;
        if (easing) {
            const maxDelay = total * duration;
            const easingFunction = (0, $a5838e105309f1af$export$9681b459c1c8f0f4)(easing);
            delay = easingFunction(delay / maxDelay) * maxDelay;
        }
        return start + delay;
    };
}
function $9c5540e6e2a50ade$export$a7952f4918e96441(from, total) {
    if (from === "first") return 0;
    else {
        const lastIndex = total - 1;
        return from === "last" ? lastIndex : lastIndex / 2;
    }
}
function $9c5540e6e2a50ade$export$4cf8f03b86be8175(option, i, total) {
    return (0, $cbc813b470d2e71a$export$f6e2535fb5126e54)(option) ? option(i, total) : option;
}


function $a4ef3c5815e968bc$export$2a47ca22dbf0bb08(AnimatePolyfill) {
    return function animate(elements, keyframes, options = {}) {
        elements = (0, $f571a32549c818c8$export$90ceba2564a894f8)(elements);
        const numElements = elements.length;
        (0, $4fd1ae9b00853f6f$export$f5708dca728d7177)(Boolean(numElements), "No valid element provided.");
        (0, $4fd1ae9b00853f6f$export$f5708dca728d7177)(Boolean(keyframes), "No keyframes defined.");
        /**
         * Create and start new animations
         */ const animationFactories = [];
        for(let i = 0; i < numElements; i++){
            const element = elements[i];
            for(const key in keyframes){
                const valueOptions = (0, $14bcec4e4efa8097$export$d2312e68e1f5ad00)(options, key);
                valueOptions.delay = (0, $9c5540e6e2a50ade$export$4cf8f03b86be8175)(valueOptions.delay, i, numElements);
                const animation = (0, $a3dd283a70afc00d$export$c76cd972d26986f9)(element, key, keyframes[key], valueOptions, AnimatePolyfill);
                animationFactories.push(animation);
            }
        }
        return (0, $5bb653941caaff3c$export$c5e4bb50450218c1)(animationFactories, options, /**
         * TODO:
         * If easing is set to spring or glide, duration will be dynamically
         * generated. Ideally we would dynamically generate this from
         * animation.effect.getComputedTiming().duration but this isn't
         * supported in iOS13 or our number polyfill. Perhaps it's possible
         * to Proxy animations returned from animateStyle that has duration
         * as a getter.
         */ options.duration);
    };
}


const $58860c6fe607092e$export$e3607ec2d7a891c4 = (0, $a4ef3c5815e968bc$export$2a47ca22dbf0bb08)((0, $6833b212a66a13ab$export$c35d437ae5945fcd));




function $412ac00cff8309b0$export$290670472807ab5b(target, options = {}) {
    return (0, $5bb653941caaff3c$export$c5e4bb50450218c1)([
        ()=>{
            const animation = new (0, $6833b212a66a13ab$export$c35d437ae5945fcd)(target, [
                0,
                1
            ], options);
            animation.finished.catch(()=>{});
            return animation;
        }
    ], options, options.duration);
}
function $412ac00cff8309b0$export$e3607ec2d7a891c4(target, keyframesOrOptions, options) {
    const factory = (0, $cbc813b470d2e71a$export$f6e2535fb5126e54)(target) ? $412ac00cff8309b0$export$290670472807ab5b : (0, $58860c6fe607092e$export$e3607ec2d7a891c4);
    return factory(target, keyframesOrOptions, options);
}


class $083da5d524f12a30$export$2e2bcd8739ae039 extends HTMLElement {
    connectedCallback() {
        const template = document.getElementById("header-template");
        const content = template.content.cloneNode(true);
        this.appendChild(content);
        const heading = JSON.parse(this.dataset.heading);
        this.querySelector("h1").innerText = heading;
    }
}
customElements.define("header-item", $083da5d524f12a30$export$2e2bcd8739ae039);


class $a11527968491234f$export$2e2bcd8739ae039 extends HTMLElement {
    connectedCallback() {
        this.render();
    }
    render() {
        const template = document.getElementById("home-view-template");
        const content = template.content.cloneNode(true);
        this.appendChild(content);
    }
}
customElements.define("home-view", $a11527968491234f$export$2e2bcd8739ae039);


class $5db92087790a37e5$export$2e2bcd8739ae039 extends HTMLElement {
    connectedCallback() {
        const template = document.getElementById("project-item-template");
        const content = template.content.cloneNode(true);
        this.appendChild(content);
        const project = JSON.parse(this.dataset.project);
        const projectImg = this.querySelector("img");
        projectImg.src = `/public${project.img}`;
        projectImg.title = project.title + " image preview";
        projectImg.alt = project.title + " image preview";
        this.querySelector("h2").textContent = project.title;
        this.querySelector("h3").textContent = project.type;
        this.querySelector(".project__description").textContent = project.description;
        const builtWith = project.builtWith.map((item, index)=>{
            return index < project.builtWith.length - 1 ? `<span><span class="project__builtWith-item">${item}</span>, </span>` : `<span>and <span class="project__builtWith-item">${item}</span>.</span>`;
        });
        this.querySelector(".project__builtwith").innerHTML = "Built with " + builtWith.join(' ');
        const headingTop = this.querySelector(".project__heading-top");
        const isFeatured = project.featured === "true";
        const featuredStar = document.createElement("img");
        featuredStar.src = "/public/star.png";
        featuredStar.alt = "Featured project icon, a yellow star";
        featuredStar.id = "project__featured-icon";
        if (isFeatured) headingTop.appendChild(featuredStar);
        const viewButton = this.querySelector("#project__button-view");
        const githubButton = this.querySelector("#project__button-github");
        const disableButtons = (type)=>{
            if (project.buttonsEnabled === "11") return type === "view" ? project.projectLink : project.githubLink;
            else if (project.buttonsEnabled === "01") {
                viewButton.classList.replace("project__button", "project__button-disabled");
                viewButton.removeAttribute("rel");
                viewButton.addEventListener("click", ()=>{});
                return type === "view" ? "#" : project.githubLink;
            } else if (project.buttonsEnabled === "10") {
                githubButton.classList.replace("project__button", "project__button-disabled");
                githubButton.removeAttribute("rel");
                githubButton.addEventListener("click", ()=>{});
                return type === "github" ? "#" : project.projectLink;
            } else return "#";
        };
        viewButton.href = disableButtons("view");
        viewButton.title = project.title + " project view link";
        githubButton.href = disableButtons("github");
        githubButton.title = project.title + " project github link";
    }
}
customElements.define("project-item", $5db92087790a37e5$export$2e2bcd8739ae039);


const $77a37b069ba56267$var$projectsData = [
    {
        "id": 0,
        "title": "Interpreter in TypeScript",
        "type": "Solo-Project",
        "description": "A programming language interpreter is an essential foundational element of many high-level programming languages (ie. JavaScript), allowing the translating and executing of input code. Building this interpreter was definitely one of the most complicated personal coding projects I\u2019ve done, but also the most interesting and satisfying. It demands a deep understanding of language syntax, semantics, and software architecture to ensure efficient code interpretation. There are many intertwined components that make up the interpreter process, from the lexer, AST, parser, environment, object based value system, to the evaluator. Check out the website to test the interpreter, see the code, and learn what an interpreter is, how it works, and how I built all of this! It was built with a frontend of vanilla JavaScript, HTML, CSS, Xterm.js, and Highlight.js, and a backend to separate the interpreter logic with Node.js, Websockets, and Express.js.",
        "builtWith": [
            "TypeScript",
            "Jest",
            "JavaScript",
            "Node.js",
            "HTML",
            "CSS",
            "Express.js"
        ],
        "projectLink": "https://ts-interpreter-gilt.vercel.app/",
        "githubLink": "https://github.com/bridgerbrown/ts-interpreter",
        "date": "March 2024",
        "img": "/project-previews/ts-interpreter-preview.webp",
        "featured": "true",
        "buttonsEnabled": "11"
    },
    {
        "id": 1,
        "title": "DayNotes",
        "type": "Solo-Project",
        "description": "(TEMPORARY DISABLED) A MERN full-stack date-based note taking platform that uses web sockets for seamless synchronization between browser tabs. Through Socket.io, the client-side website communicates with the back-end server built with Node.js and Express.js to save notes made with the Quill.js text editor to a MongoDB database. Users log in securely through cookie-based authentication sent through the Next.js and Express.js routes.",
        "builtWith": [
            "Node.js",
            "Express.js",
            "Socket.io",
            "React",
            "TypeScript",
            "MongoDB",
            "Quill.js",
            "Date-fns",
            "HTTP",
            "BCrypt",
            "TailwindCSS",
            "NextJS"
        ],
        "projectLink": "https://daynotes-client.vercel.app",
        "githubLink": "https://github.com/bridgerbrown/daynotes",
        "date": "July 2023",
        "img": "/project-previews/daynotes-preview.webp",
        "featured": "true",
        "buttonsEnabled": "01"
    },
    {
        "id": 2,
        "title": "PayCats (Venmo/Paypal Clone)",
        "type": "Solo-Project",
        "description": "A Venmo/Paypal clone with a database of cat users you can securely sign up, pay and request money from. Like Venmo, you can track your balance, make requests to users, and interact with the history of transactions. Each cat user has a different personality with unique possibilities of responses and comments to your requests!",
        "builtWith": [
            "TypeScript",
            "React",
            "Tailwind CSS",
            "NextJS",
            "Firestore database",
            "Firebase user authentication"
        ],
        "projectLink": "https://paycats.vercel.app/",
        "githubLink": "https://github.com/bridgerbrown/paycats",
        "date": "April 2023",
        "img": "/project-previews/paycats-preview.webp",
        "featured": "true",
        "buttonsEnabled": "11"
    },
    {
        "id": 3,
        "title": "Python Web Scraper",
        "type": "Solo-Project",
        "description": "An HTML web scraper with a back-end built in Python which retrieves specified elements from any given website. The Flask backend server, which listens to the front-end, initiates a request to the website and utilizes the BeautifulSoup library to parse the HTML data. After processing the data with the Pandas library, it is transmitted in a parsed JSON format to the front-end to then be displayed.",
        "builtWith": [
            "Python",
            "Flask",
            "BeautifulSoup",
            "Requests",
            "Pandas",
            "React",
            "TypeScript",
            "NextJS",
            "TailwindCSS",
            "Render"
        ],
        "projectLink": "https://web-scraper-python.vercel.app/",
        "githubLink": "https://github.com/bridgerbrown/web-scraper-python",
        "date": "September 2023",
        "img": "/project-previews/webscraper-preview.webp",
        "featured": "false",
        "buttonsEnabled": "01"
    },
    {
        "id": 4,
        "title": "Portfolio Website",
        "type": "Solo-Project",
        "description": "A single page application portfolio website built using vanilla JavaScript, HTML, and CSS for a lightweight blazingly fast experience. Dynamic content like project category filters utilizes the cloning of HTML templates.",
        "builtWith": [
            "JavaScript",
            "HTML",
            "CSS",
            "Motion One",
            "Parcel build"
        ],
        "projectLink": "https://bridgerbrown.dev/",
        "githubLink": "https://github.com/bridgerbrown/portfolio-v3",
        "date": "December 2023",
        "img": "/project-previews/portfolio-v3-preview.webp",
        "featured": "false",
        "buttonsEnabled": "11"
    },
    {
        "id": 5,
        "title": "Ecommerce Paintings",
        "type": "Solo-Project",
        "description": "An eCommerce platform that fetches painting data from a public museum's RESTful API and uses it to showcase demo products for user interaction. The website includes features like real-time product stock updates from a Firestore database, shopping cart functionality, and basic user email authentication through Firebase.",
        "builtWith": [
            "React",
            "RESTful API",
            "NextJS",
            "HTML",
            "CSS",
            "Firestore database",
            "Firebase user authentication",
            "the public art database API of the Art Institute of Chicago"
        ],
        "projectLink": "https://ecommerce-paintings.vercel.app",
        "githubLink": "https://github.com/bridgerbrown/ecommerce-paintings",
        "date": "January 2023",
        "img": "/project-previews/ecommerce-preview.webp",
        "featured": "true",
        "buttonsEnabled": "11"
    },
    {
        "id": 6,
        "title": "3D Spheres Scrolling Animation",
        "type": "Solo-Project",
        "description": "A 3D environment scrolling animation using a mars-themed sky texture and rotating reflective spheres, made using Three.js and WebGL.",
        "builtWith": [
            "Three.js",
            "WebGL",
            "React"
        ],
        "projectLink": "https://mars-sphere-animation.vercel.app/",
        "githubLink": "https://github.com/bridgerbrown/mars-spheres-animation",
        "date": "April 2023",
        "img": "/project-previews/spheres-preview.webp",
        "featured": "false",
        "buttonsEnabled": "11"
    },
    {
        "id": 7,
        "title": "Quizzical Trivia Game",
        "type": "Solo-Project",
        "description": "A trivia question game with multiple categories and difficulties, this React app fetches data from the Open Trivia Database API. This project started out as a part of the Scrimba Front-End Developer Career Path but was fleshed out more on its own.",
        "builtWith": [
            "React",
            "NextJS",
            "REST API",
            "CSS"
        ],
        "projectLink": "https://quiz-o8z5ipsoe-bridgerbrown.vercel.app/",
        "githubLink": "https://github.com/bridgerbrown/quiz-app-project",
        "date": "October 2022",
        "img": "/project-previews/quizzical-preview.webp",
        "featured": "false",
        "buttonsEnabled": "11"
    }
];
var $77a37b069ba56267$export$2e2bcd8739ae039 = $77a37b069ba56267$var$projectsData;



class $a21c6170d037a7b6$export$2e2bcd8739ae039 extends HTMLElement {
    constructor(){
        super();
        this.isAppended = false;
    }
    connectedCallback() {
        this.render();
        this.querySelector(".projects__modal").showModal();
        window.addEventListener("categorychange", ()=>{
            this.render();
        });
    }
    getProjectsLength(category) {
        const allProjects = (0, $77a37b069ba56267$export$2e2bcd8739ae039);
        const featuredProjects = (0, $77a37b069ba56267$export$2e2bcd8739ae039).filter((project)=>project.featured === "true");
        const soloProjects = (0, $77a37b069ba56267$export$2e2bcd8739ae039).filter((project)=>project.type === "Solo-Project");
        const workProjects = (0, $77a37b069ba56267$export$2e2bcd8739ae039).filter((project)=>project.type !== "Solo-Project");
        const selectedProjects = category === 'all' ? allProjects : category === 'solo-projects' ? soloProjects : category === 'featured' ? featuredProjects : workProjects;
        return selectedProjects.length;
    }
    renderCategoryRadio() {
        const categoriesData = [
            {
                value: "all",
                display: "All",
                length: this.getProjectsLength("all")
            },
            {
                value: "featured",
                display: "Featured",
                length: this.getProjectsLength("featured")
            },
            {
                value: "solo-projects",
                display: "Personal",
                length: this.getProjectsLength("solo-projects")
            },
            {
                value: "work",
                display: "Work",
                length: this.getProjectsLength("work")
            }
        ];
        const radioContainer = document.querySelector(".projects__categories-container");
        radioContainer.innerHTML = "";
        categoriesData.forEach((category)=>{
            const input = document.createElement("input");
            input.type = "radio";
            input.className = "projects__category-input";
            input.id = "category-input";
            input.name = "categories";
            input.value = category.value;
            input.checked = app.categories.category === category.value;
            input.title = "Projects " + category.value + " category filter";
            input.alt = "Projects " + category.value + " category filter";
            radioContainer.appendChild(input);
            const label = document.createElement("label");
            label.htmlFor = category.value;
            label.className = "projects__category-label";
            label.id = `${category.value}-label`;
            label.innerText = app.categories.category === category.value ? `${category.display} (${category.length})` : `${category.display}`;
            label.title = "Projects " + category.value + " category filter";
            label.alt = "Projects " + category.value + " category filter";
            radioContainer.appendChild(label);
            label.addEventListener("click", (event)=>{
                app.categories.category = category.value;
            });
        });
    }
    renderProjects() {
        const allProjects = (0, $77a37b069ba56267$export$2e2bcd8739ae039);
        const featuredProjects = (0, $77a37b069ba56267$export$2e2bcd8739ae039).filter((project)=>project.featured === "true");
        const soloProjects = (0, $77a37b069ba56267$export$2e2bcd8739ae039).filter((project)=>project.type === "Solo-Project");
        const workProjects = (0, $77a37b069ba56267$export$2e2bcd8739ae039).filter((project)=>project.type !== "Solo-Project");
        const category = app.categories.category;
        const selectedProjects = category === 'all' ? allProjects : category === 'solo-projects' ? soloProjects : category === 'featured' ? featuredProjects : workProjects;
        const projectsContainer = document.querySelector("#projects__content-container");
        projectsContainer.innerHTML = "";
        selectedProjects.map((project)=>{
            const item = document.createElement("project-item");
            item.dataset.project = JSON.stringify(project);
            projectsContainer.appendChild(item);
        });
    }
    render() {
        const template = document.getElementById("projects-view-template");
        if (!this.isAppended) {
            const content = template.content.cloneNode(true);
            this.appendChild(content);
            this.isAppended = true;
        }
        this.renderCategoryRadio();
        this.renderProjects();
        const headerContainer = document.getElementById("header__container-projects");
        headerContainer.innerHTML = "";
        const header = document.createElement("header-item");
        header.dataset.heading = JSON.stringify("Projects");
        headerContainer.appendChild(header);
        document.querySelector(".footer__text").textContent = "Created by Bridger Brown";
    }
}
customElements.define("projects-view", $a21c6170d037a7b6$export$2e2bcd8739ae039);


class $834af74b95bb33aa$export$2e2bcd8739ae039 extends HTMLElement {
    connectedCallback() {
        this.render();
    }
    resumeConfirmation(state) {
        const resumeButton = document.getElementById("about__button-resume");
        const resumeQuestion = document.getElementById("about__resume-confirmation");
        if (state === "start") {
            resumeButton.style.opacity = 0;
            resumeButton.style.position = "fixed";
            resumeQuestion.style.opacity = 1;
            resumeQuestion.style.position = "relative";
        } else {
            resumeButton.style.opacity = 1;
            resumeButton.style.position = "relative";
            resumeQuestion.style.opacity = 0;
            resumeQuestion.style.position = "fixed";
        }
    }
    downloadResume() {
        window.open('/static/public/Bridger_Brown_Resume_2023.docx', '_blank');
    }
    render() {
        const template = document.getElementById("about-view-template");
        const content = template.content.cloneNode(true);
        this.appendChild(content);
        const headerContainer = document.getElementById("header__container-about");
        const header = document.createElement("header-item");
        header.dataset.heading = JSON.stringify("About");
        headerContainer.appendChild(header);
        const resumeButton = document.getElementById("about__button-resume");
        resumeButton.onclick = ()=>this.resumeConfirmation("start");
        const confirmButton = document.getElementById("about__resume-confirm");
        const exitButton = document.getElementById("about__resume-exit");
        confirmButton.onclick = ()=>{
            this.downloadResume();
            this.resumeConfirmation("exit");
        };
        exitButton.onclick = ()=>this.resumeConfirmation("exit");
    }
}
customElements.define("about-view", $834af74b95bb33aa$export$2e2bcd8739ae039);


class $8459a322ffcfc802$export$2e2bcd8739ae039 extends HTMLElement {
    connectedCallback() {
        this.render();
    }
    copyContact() {
        const secret = [
            'm',
            'o',
            'c',
            '.',
            'l',
            'i',
            'a',
            'm',
            'g',
            '@',
            'v',
            'e',
            'd',
            'n',
            'w',
            'o',
            'r',
            'b',
            'r',
            'e',
            'g',
            'd',
            'i',
            'r',
            'b'
        ];
        navigator.clipboard.writeText(secret.reverse().join(''));
        const button = document.getElementById("contact__email-button");
        button.innerText = "Copied! \u2714";
        setTimeout(()=>{
            button.innerText = "Copy Email";
        }, 3000);
    }
    render() {
        const template = document.getElementById("contact-view-template");
        const content = template.content.cloneNode(true);
        this.appendChild(content);
        const headerContainer = document.getElementById("header__container-contact");
        const header = document.createElement("header-item");
        header.dataset.heading = JSON.stringify("Contact");
        headerContainer.appendChild(header);
        const emailButton = document.getElementById("contact__email-button");
        emailButton.onclick = ()=>this.copyContact();
    }
}
customElements.define("contact-view", $8459a322ffcfc802$export$2e2bcd8739ae039);


window.app = {};
const $ef16502092048421$var$$ = ()=>document.querySelector.call(undefined, arguments);
const $ef16502092048421$var$$$ = ()=>document.querySelectorAll.call(undefined, arguments);
HTMLElement.prototype.on = ()=>undefined.addEventListener.call(undefined, arguments);
HTMLElement.prototype.off = ()=>undefined.removeEventListener.call(undefined, arguments);
HTMLElement.prototype.$ = ()=>undefined.querySelector.call(undefined, arguments);
HTMLElement.prototype.$ = ()=>undefined.querySelectorAll.call(undefined, arguments);
app.router = (0, $c51840d17bac8a0c$export$2e2bcd8739ae039);
app.categories = (0, $2dea89c2310cd25f$export$2e2bcd8739ae039);
window.addEventListener("DOMContentLoaded", ()=>{
    app.router.init();
    const pages = [
        ".page__home",
        "projects-view",
        "about-view",
        "contact-view"
    ];
    pages.forEach((item)=>{
        (0, $412ac00cff8309b0$export$e3607ec2d7a891c4)(item, {
            opacity: [
                0,
                1
            ]
        }, {
            duration: 0.5,
            easing: "ease-in-out"
        });
    });
    (0, $412ac00cff8309b0$export$e3607ec2d7a891c4)(".home__heading-container h1", {
        opacity: [
            0,
            1
        ]
    }, {
        duration: 1.3,
        delay: 0.5
    });
    (0, $412ac00cff8309b0$export$e3607ec2d7a891c4)(".home__heading-container h2", {
        opacity: [
            0,
            1
        ]
    }, {
        duration: 1.3,
        delay: 1.3
    });
    (0, $412ac00cff8309b0$export$e3607ec2d7a891c4)("project-item", {
        opacity: [
            0,
            1
        ]
    }, {
        duration: 0.5,
        easing: "ease-in-out",
        delay: (0, $9c5540e6e2a50ade$export$ef0b4d89074db4d0)(0.3)
    });
});


//# sourceMappingURL=frontend.16282a63.js.map
